import { useState } from 'react'
import { GuideDialogShell } from './GuideDialogShell'

/**
 * Layer B: per-surface feature guide.
 */
export function FeatureGuideDialog({ open, content, onClose, onComplete }) {
  const [stepIndex, setStepIndex] = useState(0)

  if (!content?.steps?.length) return null

  const steps = content.steps
  const step = steps[stepIndex]
  const isMultiStep = steps.length > 1
  const showEyebrow = isMultiStep && step.title !== content.title

  const handleClose = () => {
    setStepIndex(0)
    onClose()
  }

  const handleFinish = () => {
    setStepIndex(0)
    onComplete()
  }

  return (
    <GuideDialogShell
      open={open}
      eyebrow={showEyebrow ? content.title : undefined}
      title={isMultiStep ? step.title : content.title}
      stepIndex={stepIndex}
      stepCount={steps.length}
      previewKey={step.previewKey}
      body={step.body}
      onClose={handleClose}
      onBack={stepIndex > 0 ? () => setStepIndex((i) => i - 1) : undefined}
      onNext={() => setStepIndex((i) => Math.min(i + 1, steps.length - 1))}
      onFinish={handleFinish}
      showSecondary={false}
      showBrand={false}
      primaryLabel={stepIndex === steps.length - 1 ? 'Done' : 'Next'}
    />
  )
}
